//历史项目查询
import './index.scss'

import { getProjectListAPI, cancelProjectAPI, getProjectByNameAPI } from "@/apis/project";
import { Table, Space, Button, Flex, Input, Tag, message, Popconfirm } from "antd"
import { useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom'
import { useTranslation } from "react-i18next";
import { useSelector } from 'react-redux';

// import { useForm } from 'antd/es/form/Form';

// Removed RangePicker usage in this simplified view
const ShowProject = () => {
    const [messageApi, contextHolder] = message.useMessage();

    // Removed update/delete related form state

    const [checkProjectName, setCheckProjectName] = useState('')

    const success = (msg) => {
        messageApi.success(msg);
    }
    const error = (msg) => {
        messageApi.error(msg);
    };

    //查询项目名称
    const handleCheckProjectNameChange = (e) => {
        setCheckProjectName(e.target.value)
    }
    async function handleConsultProjectName() {
        try {
            // 验证输入是否为空
            if (!checkProjectName.trim()) {
                setTimeout(() => {
                    window.location.reload();
                }, 100);
                return;
            }
            const res = await getProjectByNameAPI(checkProjectName)
            setProjectList(res.data)
        } catch (error) {
            console.error(error);
            return;
        }

        // window.location.reload();
    }

    // 取消项目
    const handleCancelProject = async (id) => {
        try {
            const res = await cancelProjectAPI(id)
            if (res.code === 0) {
            success('项目已取消')
            const projectRes = await getProjectListAPI();
            setProjectList(projectRes.data)
            } else {
            error(res.data || '取消失败')
            }
        } catch (e) {
            error('取消失败')
        }
    }

    // 下载舞步文件占位函数后续实现

    const { t } = useTranslation();

    const columns = [
        {
            title: t('ProjectAdditionFormList.ProjectName'),
            dataIndex: 'projectName',
            key: 'projectName',
        },
        {
            title: t('FormList.ProjectStartDate'),
            dataIndex: 'projectStartTime',
            key: 'projectStartTime',
            sorter: (a, b) => new Date(a.projectStartTime) - new Date(b.projectStartTime),
        },
        {
            title: t('FormList.ProjectEndDate'),
            dataIndex: 'projectEndTime',
            key: 'projectEndTime',
            sorter: (a, b) => new Date(a.projectEndTime) - new Date(b.projectEndTime),
        },
        {
            title: t('ProjectAdditionFormList.UavNum'),
            dataIndex: 'uavNum',
            key: 'uavNum',
            sorter: (a, b) => a.uavNum - b.uavNum,
        },
        {
            title: '项目状态',
            key: 'statusCombined',
            render: (_, record) => {
                const ps = record.projectStatus
                let statusTag
                if (ps === 100) statusTag = <Tag color='green'>已结束</Tag>
                else if (ps === 101) statusTag = <Tag color='red'>已取消</Tag>
                else statusTag = <Tag color='blue'>未完成</Tag>

                const placeTag = record.execPlace ? <Tag color='green'>已关联场地</Tag> : <Tag color='default'>未关联场地</Tag>
                const fileTag = (record.fileCount && record.fileCount > 0) ? <Tag color='green'>已上传设计文件</Tag> : <Tag color='warning'>设计文件未上传</Tag>
                return <Space size={[4,4]} wrap>{statusTag}{placeTag}{fileTag}</Space>
            }
        },
        {
            title: t('FormList.Action'),
            key: 'action',
            render: (_, record) => {
                const status = record.projectStatus
                const isFinished = status === 100
                const isCanceled = status === 101
                const showDetailOnly = isFinished || isCanceled
                return (
                    <Space size='middle'>
                        <Button type='primary' onClick={() => toProjectDetail(record.id)}>
                            {showDetailOnly ? '项目详情' : '下一步'}
                        </Button>
                        {!showDetailOnly && (
                            <Popconfirm title='确认取消该项目?' onConfirm={() => handleCancelProject(record.id)} okText='确认' cancelText='取消'>
                                <Button danger>取消项目</Button>
                            </Popconfirm>
                        )}
                    </Space>
                )
            }
        }
    ]

    // Removed projectCheckStep related options

    const [projectList, setProjectList] = useState([])
    const navigate = useNavigate()

    const toProjectDetail = (id) => {
        navigate(`/ProjectDetail?id=${id}`)
    }

    useEffect(() => {
        const getProjectList = async () => {
            const res = await getProjectListAPI()
            setProjectList(res.data)
        }
        getProjectList()
    }, [])

    // Removed obsolete effect for update modal

    return (
        <Flex vertical>
            {contextHolder}
            <div style={{ display: Flex, justifyContent: 'space-between', marginBottom: 20 }}>
                <Input value={checkProjectName} placeholder={t('ProjectAdditionFormList.ProjectName')} style={{ width: 150, marginRight: 10 }} onChange={handleCheckProjectNameChange} />
                <Button type="primary" onClick={handleConsultProjectName}>{t('ButtonList.Search')}</Button>
            </div>
            <Table
                className="projectForm"
                dataSource={projectList}
                columns={columns}
                rowKey={(record) => record.id}
                scroll={{ x: 'max-content' }}
                size="small"
                style={{ whiteSpace: 'nowrap' }}
                components={{
                    body: {
                        cell: (props) => (
                            <td {...props} style={{ ...props.style, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }} />
                        ),
                    },
                }} >
            </Table>
        </Flex>
    )
}
export default ShowProject